export default "__VITE_ASSET__c99c8284__"